import { useEffect, useState } from "react";
import { Rocket } from "lucide-react";

// June 22, 2026 at 9:00 AM America/New_York. June = EDT (UTC−4).
const GA_LAUNCH_MS = Date.parse("2026-06-22T09:00:00-04:00");

const pad = (n: number) => String(n).padStart(2, "0");

function parts(ms: number) {
  const sec = Math.max(0, Math.floor(ms / 1000));
  return {
    days: Math.floor(sec / 86400),
    hours: Math.floor((sec % 86400) / 3600),
    mins: Math.floor((sec % 3600) / 60),
    secs: sec % 60,
  };
}

// All countdown text renders in white against the navy sidebar background.
const GRADIENT_TEXT = "text-white";

function Unit({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex flex-col items-center leading-none">
      <span className={`text-h3 font-bold tabular drop-shadow-sm md:text-h2 ${GRADIENT_TEXT}`}>
        {value}
      </span>
      <span className={`mt-0.5 text-[9px] font-semibold uppercase tracking-[0.14em] md:text-[10px] ${GRADIENT_TEXT}`}>
        {label}
      </span>
    </div>
  );
}

export function TopCountdownBanner() {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const delta = GA_LAUNCH_MS - now;
  const launched = delta <= 0;
  const { days, hours, mins, secs } = parts(delta);

  return (
    <div className="flex min-h-[64px] w-full shrink-0 items-center justify-center gap-4 bg-sidebar px-4 py-2 text-white md:min-h-[72px] md:gap-6">
      <div className="flex items-center gap-2 md:gap-3">
        <Rocket size={18} className="shrink-0 text-[#ec67a0] drop-shadow-sm md:h-5 md:w-5" />
        <span className={`text-caption font-semibold uppercase tracking-wider md:text-body ${GRADIENT_TEXT}`}>
          {launched ? "Felix GA is LIVE" : "Felix GA launches in"}
        </span>
      </div>
      {!launched && (
        <div className="flex items-center gap-3 md:gap-5">
          <Unit value={String(days)} label="Days" />
          <span className={`-mt-3 text-h3 font-bold md:text-h2 ${GRADIENT_TEXT}`}>:</span>
          <Unit value={pad(hours)} label="Hours" />
          <span className={`-mt-3 text-h3 font-bold md:text-h2 ${GRADIENT_TEXT}`}>:</span>
          <Unit value={pad(mins)} label="Mins" />
          <span className={`-mt-3 hidden text-h3 font-bold sm:inline md:text-h2 ${GRADIENT_TEXT}`}>:</span>
          <div className="hidden sm:block"><Unit value={pad(secs)} label="Secs" /></div>
        </div>
      )}
    </div>
  );
}
